export default __webpack_public_path__ + "static/media/hero.7612eabe.gif";